import Swiper from 'swiper/bundle';

const IconColumns = () => {
  const sliders = document.querySelectorAll('.icon-columns__swiper');
  if (!sliders.length) return;

  const swiperInstances = new WeakMap(); // track instances per DOM node

  const initOrDestroySwiper = () => {
    const isMobile = window.innerWidth < 1024;

    sliders.forEach((slider) => {
      const hasInstance = swiperInstances.has(slider);

      if (isMobile && !hasInstance) {
        const swiper = new Swiper(slider, {
          slidesPerView: 'auto',
          spaceBetween: 10,
          loop: true,
          navigation: {
            nextEl: slider.querySelector('.icon-columns__nav--next'),
            prevEl: slider.querySelector('.icon-columns__nav--prev'),
          },
        });

        swiperInstances.set(slider, swiper);
      }

      if (!isMobile && hasInstance) {
        const swiper = swiperInstances.get(slider);
        swiper.destroy(true, true);
        swiperInstances.delete(slider);
      }
    });
  };

  // Initial check
  initOrDestroySwiper();

  // Re-check on resize
  window.addEventListener('resize', () => {
    initOrDestroySwiper();
  });
};

export default IconColumns;
